export const GET_UPCOMING_TASKS = 'GET_UPCOMING_TASKS';
export const GET_UPCOMING_TASKS_SUCCESS = 'GET_UPCOMING_TASKS_SUCCESS';
